<div id="identifyGame" *ngIf="label">

  <div class="row mx-0 justify-content-center" *ngIf="start">
    <div class="col-12 col-md-auto pt-3">
      <div class="gameTitle gameTitleSm {{lang}}">{{ label[lang].identifyGame }}</div>
    </div>
    <div class="col text-left text-md-right align-self-center mb-3 mb-lg-0">
      <div class="quizPagin" *ngIf="questionNum > 0">
        <!-- {{ label[lang].num }} {{ questionNum }}{{ label[lang].ques }}, {{ label[lang].total }} {{ questionList.length }}
        {{ label[lang].ques }} -->
        <ng-container *ngIf="lang === 'tc'">
          {{ label[lang].num }} {{ questionNum }}{{ label[lang].ques }}, {{ label[lang].total }}
          {{ questionList.length }}
          {{ label[lang].ques }}
        </ng-container>
        <ng-container *ngIf="lang === 'sc'">
          {{ label[lang].num }} {{ questionNum }}{{ label[lang].ques }}, {{ label[lang].total }}
          {{ questionList.length }}
          {{ label[lang].ques }}
        </ng-container>
        <ng-container *ngIf="lang === 'en'">
          {{ label[lang].num }} {{ questionNum }}, {{ label[lang].total }} {{ questionList.length }}
          {{ label[lang].ques }}s
        </ng-container>
      </div>

      <ng-container *ngIf="lang === 'tc'">
        <img class="img-fluid gameReset" src="{{imgpath}}/restart_btn_tc.png" (click)="gameReset()" />
      </ng-container>
      <ng-container *ngIf="lang === 'sc'">
        <img class="img-fluid gameReset" src="{{imgpath}}/restart_btn_sc.png" (click)="gameReset()" />
      </ng-container>
      <ng-container *ngIf="lang === 'en'">
        <img class="img-fluid gameReset" src="{{imgpath}}/restart_btn_en.png" (click)="gameReset()" />
      </ng-container>

    </div>
  </div>

  <div class="quizGameWrap {{ lang }}" [ngClass]="{'firstBg': !start}">
    <div>

      <div class="row mx-0 justify-content-center" *ngIf="!start">
        <div class="col-12 col-md-11 col-lg-8 mb-3 mb-lg-0">

          <div class="ruleDesc identificationGameDesc">
            <div class="gameTitle {{lang}}">{{ label[lang].identifyGame }}</div>
            <div>
              <label class="{{lang}}">{{ label[lang].gameRule }}</label>
            </div>
            <div>
              {{ label[lang].game3Landing }}<br />
              <br />
            </div>
            <!-- <ul>
              <li>遊戲規則 1 遊戲規則 1 遊戲規則 1</li>
              <li>遊戲規則 2 遊戲規則 2 遊戲規則 2</li>
              <li>遊戲規則 3 遊戲規則 3 遊戲規則 3</li>
            </ul> -->

            <ng-container *ngIf="lang === 'tc'">
              <img class="img-fluid gameStart mb-4 mb-lg-5" src="{{imgpath}}/start_btn_tc.png" (click)="gameStart()">
            </ng-container>
            <ng-container *ngIf="lang === 'sc'">
              <img class="img-fluid gameStart mb-4 mb-lg-5" src="{{imgpath}}/start_btn_sc.png" (click)="gameStart()">
            </ng-container>
            <ng-container *ngIf="lang === 'en'">
              <img class="img-fluid gameStart mb-4 mb-lg-5" src="{{imgpath}}/start_btn_en.png" (click)="gameStart()">
            </ng-container>

          </div>

        </div>
      </div>

      <div class="row mx-0 justify-content-center" *ngIf="start && !showResult && !questionNum">
        <div class="col-12 col-md-12 col-lg-10">

          <div class="gameTitle gameTitleSm {{lang}}">{{ label[lang].pleaseIdentify }}</div>
          <div class="dotLine mb-4"></div>

          <div class="row mx-0 justify-content-center">
            <div class="col-12 col-md-11 px-0 pt-4">

              <div class="row">
                <ng-container *ngFor="let type of identifyTypeList; let key = index;">
                  <div class="col-6 col-md-4 col-lg-3 px-4 pb-4">

                    <img class="img-fluid d-block mx-auto idGameTypeBlock pointer"
                      [src]="'/angular/assets/game3/' + type + '.jpg'"
                      [ngClass]="{'selectedAns': selectedIdentifyType === type}" (click)="selectIdentifyType(type)" />

                  </div>
                </ng-container>
              </div>

            </div>
          </div>

          <div class="text-center py-3 mb-5">

            <ng-container *ngIf="lang === 'tc'">
              <img class="img-fluid quizSubmit" src="{{imgpath}}/submit_btn_tc.png" (click)="identifySubmit()"
                [ngClass]="{'disable': !selectedIdentifyType}">
            </ng-container>
            <ng-container *ngIf="lang === 'sc'">
              <img class="img-fluid quizSubmit" src="{{imgpath}}/submit_btn_sc.png" (click)="identifySubmit()"
                [ngClass]="{'disable': !selectedIdentifyType}">
            </ng-container>
            <ng-container *ngIf="lang === 'en'">
              <img class="img-fluid quizSubmit" src="{{imgpath}}/submit_btn_en.png" (click)="identifySubmit()"
                [ngClass]="{'disable': !selectedIdentifyType}">
            </ng-container>

          </div>

        </div>
      </div>

      <div class="row mx-0 justify-content-center" *ngIf="start && questionNum > 0 && !showResult">
        <div class="col-12 col-md-11">

          <div class="row">
            <div class="col-12 col-lg-4 mb-4">

              <img class="img-fluid d-block mx-auto idQuestImg"
                [src]="'/angular/assets/game3/' + selectedIdentifyType + '.jpg'" />

            </div>
            <div class="col-12 col-lg">

              <div class="quesBlock row mx-0 {{ lang }}">
                <div class="col-12 col-md-auto">

                  <ng-container *ngIf="lang === 'tc'">
                    {{ label[lang].num }} {{ questionNum }} {{ label[lang].ques }}:
                  </ng-container>
                  <ng-container *ngIf="lang === 'sc'">
                    {{ label[lang].num }} {{ questionNum }} {{ label[lang].ques }}:
                  </ng-container>
                  <ng-container *ngIf="lang === 'en'">
                    {{ label[lang].num }} {{ questionNum }}:
                  </ng-container>

                </div>
                <div class="col">
                  <ng-container *ngIf="lang === 'tc'">
                    {{ questionList[questionNum-1].questionTc }}
                  </ng-container>
                  <ng-container *ngIf="lang === 'sc'">
                    {{ questionList[questionNum-1].questionSc }}
                  </ng-container>
                  <ng-container *ngIf="lang === 'en'">
                    {{ questionList[questionNum-1].questionEn }}
                  </ng-container>
                </div>
              </div>

              <div class="row">

                <ng-container *ngIf="lang === 'tc'">
                  <div class="col-12 col-md-6 mb-2"
                    *ngFor="let ans of questionList[questionNum-1].ansTc; let key = index;">

                    <div class="ansBlock idGameBlock" (click)="selectAns(ans)"
                      [ngClass]="{ 'pointer': !showAns, 'selectedAns': !showAns && ans === userSelectAns, 'disableAns': showAns && userSelectAns !== ans && ans !== questionList[questionNum-1].corrAnsTc, 'wrongAns': showAns && userSelectAns === ans && ans !== questionList[questionNum-1].corrAnsTc, 'trueAns': showAns && ans === questionList[questionNum-1].corrAnsTc }"
                      *ngIf="ans || questionList[questionNum-1].ansPhotoTc[key]">

                      <div *ngIf="questionList[questionNum-1].ansPhotoTc[key]">
                        <img class="img-fluid d-block mx-auto" [src]="questionList[questionNum-1].ansPhotoTc[key]" />
                      </div>

                      <div>{{ ansLabel[key] }}.</div>

                      <ng-container *ngIf="ans">
                        <div class="idGameAns {{ getAnsBlockHeightStyle(questionList[questionNum-1]) }}">
                          {{ ans }}
                        </div>
                      </ng-container>

                    </div>

                  </div>
                </ng-container>
                <ng-container *ngIf="lang === 'sc'">
                  <div class="col-12 col-md-6 mb-2"
                    *ngFor="let ans of questionList[questionNum-1].ansSc; let key = index;">

                    <div class="ansBlock idGameBlock" (click)="selectAns(ans)"
                      [ngClass]="{ 'pointer': !showAns, 'selectedAns': !showAns && ans === userSelectAns, 'disableAns': showAns && userSelectAns !== ans && ans !== questionList[questionNum-1].corrAnsSc, 'wrongAns': showAns && userSelectAns === ans && ans !== questionList[questionNum-1].corrAnsSc, 'trueAns': showAns && ans === questionList[questionNum-1].corrAnsSc }"
                      *ngIf="ans || questionList[questionNum-1].ansPhotoTc[key]">

                      <div *ngIf="questionList[questionNum-1].ansPhotoTc[key]">
                        <img class="img-fluid d-block mx-auto" [src]="questionList[questionNum-1].ansPhotoTc[key]" />
                      </div>

                      <div>{{ ansLabel[key] }}.</div>

                      <ng-container *ngIf="ans">
                        <div class="idGameAns {{ getAnsBlockHeightStyle(questionList[questionNum-1]) }}">
                          {{ ans }}
                        </div>
                      </ng-container>

                    </div>

                  </div>
                </ng-container>
                <ng-container *ngIf="lang === 'en'">
                  <div class="col-12 col-md-6 mb-2"
                    *ngFor="let ans of questionList[questionNum-1].ansEn; let key = index;">

                    <div class="ansBlock idGameBlock" (click)="selectAns(ans)"
                      [ngClass]="{ 'pointer': !showAns, 'selectedAns': !showAns && ans === userSelectAns, 'disableAns': showAns && userSelectAns !== ans && ans !== questionList[questionNum-1].corrAnsEn, 'wrongAns': showAns && userSelectAns === ans && ans !== questionList[questionNum-1].corrAnsEn, 'trueAns': showAns && ans === questionList[questionNum-1].corrAnsEn }"
                      *ngIf="ans || questionList[questionNum-1].ansPhotoTc[key]">

                      <div *ngIf="questionList[questionNum-1].ansPhotoTc[key]">
                        <img class="img-fluid d-block mx-auto" [src]="questionList[questionNum-1].ansPhotoTc[key]" />
                      </div>

                      <div>{{ ansLabel[key] }}.</div>

                      <ng-container *ngIf="ans">
                        <div class="idGameAns {{ getAnsBlockHeightStyle(questionList[questionNum-1]) }}">
                          {{ ans }}
                        </div>
                      </ng-container>

                    </div>

                  </div>
                </ng-container>

              </div>

              <div class="text-right mb-4">

                <ng-container *ngIf="lang === 'tc'">
                  <img class="img-fluid quizSubmit" src="{{imgpath}}/submit_btn_tc.png" (click)="questionSubmit()"
                    [ngClass]="{'disable': !userSelectAns }" *ngIf="!showAns">
                  <img class="img-fluid quizSubmit" src="{{imgpath}}/next_question_btn_tc.png" (click)="next()"
                    *ngIf="showAns">
                </ng-container>
                <ng-container *ngIf="lang === 'sc'">
                  <img class="img-fluid quizSubmit" src="{{imgpath}}/submit_btn_sc.png" (click)="questionSubmit()"
                    [ngClass]="{'disable': !userSelectAns }" *ngIf="!showAns">
                  <img class="img-fluid quizSubmit" src="{{imgpath}}/next_question_btn_sc.png" (click)="next()"
                    *ngIf="showAns">
                </ng-container>
                <ng-container *ngIf="lang === 'en'">
                  <img class="img-fluid quizSubmit" src="{{imgpath}}/submit_btn_en.png" (click)="questionSubmit()"
                    [ngClass]="{'disable': !userSelectAns }" *ngIf="!showAns">
                  <img class="img-fluid quizSubmit {{lang}}" src="{{imgpath}}/next_question_btn_en.png" (click)="next()"
                    *ngIf="showAns">
                </ng-container>

              </div>

            </div>
          </div>

        </div>
      </div>

      <div class="row mx-0 justify-content-center" *ngIf="showResult">
        <div class="col-12 col-md-10 col-lg-8">

          <div class="text-center">
            <ng-container *ngIf="lang === 'tc'">
              <img class="img-fluid finishBtn" src="{{imgpath}}/finish_title_tc.png" />
            </ng-container>
            <ng-container *ngIf="lang === 'sc'">
              <img class="img-fluid finishBtn" src="{{imgpath}}/finish_title_sc.png" />
            </ng-container>
            <ng-container *ngIf="lang === 'en'">
              <img class="img-fluid finishBtn" src="{{imgpath}}/finish_title_en.png" />
            </ng-container>
          </div>

          <div class="row mx-0 mb-4">
            <div class="col-auto align-self-center pr-4 text-right">
              <ng-container *ngIf="lang === 'tc'">
                <img class="img-fluid scoreLabel" src="{{imgpath}}/score_tc.png" />
              </ng-container>
              <ng-container *ngIf="lang === 'sc'">
                <img class="img-fluid scoreLabel" src="{{imgpath}}/score_sc.png" />
              </ng-container>
              <ng-container *ngIf="lang === 'en'">
                <img class="img-fluid scoreLabel" src="{{imgpath}}/score_en.png" />
              </ng-container>
            </div>
            <div class="col">
              <div class="scoreContent">

                <!-- <img class="img-fluid" src="{{imgpath}}/award_gold.png" /> -->
                <div class="score" [ngClass]="{'gold': getMark() === 60, 
                'silver': (getMark() > 30 && getMark() < 60), 
                'copper': (getMark() > 20 && getMark() < 40), 'addOil': (getMark() < 30)}">

                  <!-- {{ getTrueResultCounter() }} / {{ questionList.length }} -->
                  {{ getMark() }}

                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="dotLine mb-4"></div>
            <div class="resultContent text-center mb-4">

              <ng-container *ngIf="getMark() === 60">
                {{ label[lang].game3ResultGold }}
              </ng-container>
              <ng-container *ngIf="getMark() > 30 && getMark() < 60">
                {{ label[lang].game3ResultSilver }}
              </ng-container>
              <ng-container *ngIf="getMark() > 20 && getMark() < 40">
                {{ label[lang].game3ResultBronze }}
              </ng-container>
              <ng-container *ngIf="getMark() < 30">
                {{ label[lang].game3Result }}
              </ng-container>

              <!-- <table>
                <tr>
                  <td>Score Summary:</td>
                  <td>a paragraph</td>
                </tr>
                <tr>
                  <td>Score Summary:</td>
                  <td>a paragraph</td>
                </tr>
                <tr>
                  <td>Score Summary:</td>
                  <td>a paragraph</td>
                </tr>
                <tr>
                  <td>Score Summary:</td>
                  <td>a paragraph</td>
                </tr>
              </table> -->

            </div>
            <div class="dotLine mb-3"></div>
          </div>

          <div class="py-4 text-center mb-4 mb-lg-5">
            <ng-container *ngIf="lang === 'tc'">
              <img class="img-fluid gameResetFinish" src="{{imgpath}}/restart_btn_tc.png" (click)="gameReset()" />
            </ng-container>
            <ng-container *ngIf="lang === 'sc'">
              <img class="img-fluid gameResetFinish" src="{{imgpath}}/restart_btn_sc.png" (click)="gameReset()" />
            </ng-container>
            <ng-container *ngIf="lang === 'en'">
              <img class="img-fluid gameResetFinish" src="{{imgpath}}/restart_btn_en.png" (click)="gameReset()" />
            </ng-container>
          </div>

        </div>
      </div>

    </div>
  </div>

  <div class="py-3 px-2">
    <!-- <small>{{ label[lang].commonRemark }}</small> -->
    <small>{{ label[lang].seedbankRemark1 }}</small>
    <br />
    <small>{{ label[lang].seedbankRemark2 }}</small>
    <br />
    <small>{{ label[lang].seedbankRemark3 }}</small>
  </div>

</div>